import { useQuery } from 'react-query';

import api from '../../utils/api';
import { PLUGIN_OPTIONS } from '../../constants/endpoints';

const fetchPluginOptions = () => api.get(PLUGIN_OPTIONS);
export const useFetchPluginOptions = ({ enabled = true }) =>
  useQuery(PLUGIN_OPTIONS, fetchPluginOptions, {
    enabled,
    staleTime: Infinity
  });



// WEBPACK FOOTER //
// ./src/hooks/react-query/useOptionsData.js